import rules from "../src/validate";
export default {
  name: "kui-validatebox",
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      isShowTips: false,
      requiredText: "该项为必填项",
      validateMsg: "",
      rules: rules };
  },
  computed: {
    width: function width() {
      var width = parseInt(this.options.width) || 180;
      return (!!_.trim(this.options.buttonText) ? width - 40 : width) + "px";
    }
  },
  mounted: function mounted() {},

  methods: {
    showTip: function showTip(message) {
      this.isShowTips = true;
      this.validateMsg = message;
    },
    hideTips: function hideTips() {
      this.validateMsg = "";
      this.isShowTips = false;
      this.$parent.isPassValidate = true;
    },
    validate: function validate(val) {
      var validCfgs = this.options.validType || "",
          value = _.trim(val);
      this.hideTips();

      if (this.options.disabled) {
        return true;
      }
      if (this.options.required && !value) {
        this.showTip(this.requiredText);
        return false;
      }

      if (!validCfgs) {
        return true;
      }
      var result = /([a-zA-Z_]+)(.*)/.exec(validCfgs);
      var rule = this.rules[result[1]];
      var vParam = result[2].split("[")[1].split("]")[0].split(",");
      if (!rule.validator(value, vParam)) {
        this.showTip(rule.message);
        return false;
      };
      return true;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui/default/validatebox/src/validatebox.js
// module id = 1475
// module chunks = 2